import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67642634"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "circular-border" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "information" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "public-place" }
const _hoisted_8 = { class: "neighborhood" }
const _hoisted_9 = {
  key: 0,
  class: "address-extra"
}
const _hoisted_10 = {
  key: 1,
  class: "address-extra"
}
const _hoisted_11 = { class: "icons" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "address" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "public-place" }, "Retirada"),
  /*#__PURE__*/_createElementVNode("p", { class: "address-extra" }, "Retirar o pedido na loja")
], -1))
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Você não possui endereços registrados em bairros em que a loja entrega. Adicione o primeiro através no botão abaixo. ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_header_with_balance = _resolveComponent("header-with-balance")!
  const _component_ion_skeleton_text = _resolveComponent("ion-skeleton-text")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_footer = _resolveComponent("ion-footer")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_header_with_balance, {
            class: "balance-header",
            "has-go-back-modal": true,
            title: "Escolher endereço",
            "has-go-back": false
          }),
          _createElementVNode("div", _hoisted_1, [
            (_ctx.loadingRef)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(7, (i) => {
                    return _createVNode(_component_ion_card, { key: i }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_card_content, null, {
                          default: _withCtx(() => [
                            _createElementVNode("span", null, [
                              _createVNode(_component_ion_skeleton_text, { animated: "" })
                            ]),
                            _createElementVNode("div", null, [
                              _createElementVNode("p", null, [
                                _createVNode(_component_ion_skeleton_text, { animated: "" })
                              ]),
                              _createElementVNode("p", null, [
                                _createVNode(_component_ion_skeleton_text, { animated: "" })
                              ]),
                              _createElementVNode("p", null, [
                                _createVNode(_component_ion_skeleton_text, { animated: "" })
                              ]),
                              _createElementVNode("p", null, [
                                _createVNode(_component_ion_skeleton_text, { animated: "" })
                              ])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1024)
                  }), 64))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  (_ctx.addressNeighborhoodsRef.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createElementVNode("p", _hoisted_5, [
                          _createVNode(_component_ion_icon, {
                            icon: _ctx.informationCircleOutline,
                            color: "medium"
                          }, null, 8, ["icon"]),
                          _createTextVNode(" Somente são listados os endereços em que a loja entrega. ")
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.addressNeighborhoodsRef, (address) => {
                          return (_openBlock(), _createBlock(_component_ion_card, {
                            key: address.id
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_card_content, { class: "address-card" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", {
                                    class: "address",
                                    onClick: ($event: any) => (
                    _ctx.chooseAddress(
                      address,
                      address.neighborhood.name,
                      address.neighborhood.city_id,
                      address.neighborhood.deliveryFee.delivery_fee
                    )
                  )
                                  }, [
                                    _createElementVNode("p", _hoisted_7, _toDisplayString(address.street_name) + _toDisplayString(address.address_number
                        ? ", " + address.address_number
                        : ""), 1),
                                    _createElementVNode("p", _hoisted_8, _toDisplayString(address.neighborhood.name), 1),
                                    (address.complement)
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(address.complement), 1))
                                      : _createCommentVNode("", true),
                                    (address.reference)
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(address.reference), 1))
                                      : _createCommentVNode("", true)
                                  ], 8, _hoisted_6),
                                  _createElementVNode("div", _hoisted_11, [
                                    _createVNode(_component_ion_icon, {
                                      icon: _ctx.pencilOutline,
                                      onClick: ($event: any) => (_ctx.editAddress(address))
                                    }, null, 8, ["icon", "onClick"]),
                                    _createVNode(_component_ion_icon, {
                                      icon: _ctx.trashBinOutline,
                                      onClick: ($event: any) => (_ctx.alertDelete(address.id))
                                    }, null, 8, ["icon", "onClick"])
                                  ])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128)),
                        (_ctx.withDraw == true)
                          ? (_openBlock(), _createBlock(_component_ion_card, {
                              key: 0,
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.chooseAddress('withDraw')))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_card_content, null, {
                                  default: _withCtx(() => [
                                    _hoisted_12
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createVNode(_component_ion_card, { class: "card-without-addresses" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_card_content, null, {
                              default: _withCtx(() => [
                                _hoisted_14
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]))
                ]))
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_ion_footer, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_the_button, {
                name: "Adicionar endereço",
                onClick: _ctx.addAddress
              }, null, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}